module.exports = __webpack_public_path__ + "img/vsBronzer4.bf0c45b0.jpg";